import { render, staticRenderFns } from "./specialSeriesList.vue?vue&type=template&id=4c9f7b45&scoped=true"
import script from "./specialSeriesList.vue?vue&type=script&lang=js"
export * from "./specialSeriesList.vue?vue&type=script&lang=js"
import style0 from "./specialSeriesList.vue?vue&type=style&index=0&id=4c9f7b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f7b45",
  null
  
)

export default component.exports